module.exports = __webpack_public_path__ + "static/media/sample.ab31b41d.xlsx";